<template>
    <div class="d-flex align-items-center gap-1">
        <primaryButtonComponent class="button-wrapper m-0" @click="igniteDownload" :disabled="isSending" buttonWidth="fit-content" :paddingX="btnPaddingX" :paddingY="btnPaddingY">
            <template v-slot:content>
                <div class="d-flex gap-2 align-items-center">
                    <p class="extra-light-text font-weight-600">ექსპორტი</p>
                    <img v-if="!isSending" src="@/assets/images/excelExportImage.svg" alt="export">
                    <p v-else>....</p>
                </div>
            </template>
        </primaryButtonComponent>
        <button v-if="canAbortDownload && isSending" @click="abortDownload" class="abort-btn">
            <svg xmlns="http://www.w3.org/2000/svg" fill="black" width="18px" height="13px" viewBox="0 0 384 512"><path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"/></svg>
        </button>
    </div>
</template>
<script>
import * as XLSX from 'xlsx';
import primaryButtonComponent from './primaryButtonComponent.vue';
export default {
    data(){
        return {
            wch: [],
            isSending: false,
        }
    },
    components: {
        primaryButtonComponent,
    },
    watch: {
        downloadInAction(newValue){
            this.downloadInActionHandler();
        },
    },
    props: {
        excelFileName: String,
        minColumnChar: {
            type: Number,
            default: 20,
        },
        downloadInAction: Boolean,
        jsonToExcelArray: Array,
        namesArray: Array,
        jsonOrArray: { // false = json, true = array
            type: Boolean,
            default: true,
        },
        btnPaddingX: {
            type: String,
            default: "15px",
        },
        btnPaddingY: {
            type: String,
            default: "7px",
        },
        canAbortDownload: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        abortDownload(){
            this.$emit("abortDownload");
            this.isSending = false;
        },
        igniteDownload(){
            this.$emit("igniteDownload");
            this.isSending = true;
        },
        // ws['!cols'] = [
        //     { wch: 40 },
        // ];
        downloadInActionHandler(){
            
            if(!this.jsonOrArray){
                const wb = XLSX.utils.book_new();
                this.jsonToExcelArray.forEach((arrayItem, index) => {
                    const ws = XLSX.utils.json_to_sheet(arrayItem);
                    let tempArray = [];
                    arrayItem[0]?.forEach(() => {
                        tempArray.push(
                            {
                                wch: this.minColumnChar,
                            }
                        );
                    })
                    ws['!cols'] = tempArray;
                    XLSX.utils.book_append_sheet(wb, ws, this.namesArray[index]);
                });
                XLSX.writeFile(wb, `${this.excelFileName}.xlsx`, { bookType: 'xlsx', type: 'array' });
            }else{
                const wb = XLSX.utils.book_new();
                this.jsonToExcelArray.forEach((arrayItem, index) => {
                    const ws = XLSX.utils.aoa_to_sheet(arrayItem);
                    let tempArray = [];
                    arrayItem[0]?.forEach(() => {
                        tempArray.push(
                            {
                                wch: this.minColumnChar,
                            }
                        );
                    })
                    ws['!cols'] = tempArray;
                    XLSX.utils.book_append_sheet(wb, ws, this.namesArray[index]);
                });
                XLSX.writeFile(wb, `${this.excelFileName}.xlsx`, { bookType: 'xlsx', type: 'array' });
            }
            this.isSending = false;
        },
    },
}
</script>
<style>
.abort-btn{
    z-index: 20;
}
</style>